<template>
  <div class="terms-of-use">
    <b-modal
      ref="termsOfUseModal"
      centered
      :hide-header="true"
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
    >
      <div class="p-4">
        <LoaderContent v-if="isLoading" />

        <img
          src="@/assets/images/restoque/logo-restoque.png"
          alt="restoque Logotipo"
          class="mb-5 mx-auto px-5 d-block d-lg-none logo-ml-blue"
        />

        <p>
          Ao continuar, você concorda com a coleta e uso de dados pessoais para
          fins exclusivos de recrutamento e seleção. Deseja continuar?
        </p>
      </div>

      <template slot="modal-footer">
        <button type="button" class="btn btn-link" @click="notAccept()">
          Não, quero desistir
        </button>
        <button type="button" class="btn btn-blue-ml" @click="accept()">
          Sim, quero continuar
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import CloseIcon from "vue-material-design-icons/Close.vue";
import LoaderContent from "ninenine-white-label/src/components/Loader/LoaderContent.vue";

export default {
  name: "TermsOfUse",

  data() {
    return {
      isLoading: false,
    };
  },

  mounted() {
    this.$EventBus.$on("showTermsOfUse", () => {
      this.$refs["termsOfUseModal"].show();
    });
  },

  destroyed() {
    this.$EventBus.$off("showTermsOfUse");
  },

  components: {
    CloseIcon,
    LoaderContent,
  },

  methods: {
    notAccept() {
      this.isLoading = true;

      this.$swal({
        title: "Atenção",
        text: "Seu usuário será removido caso não aceite os Termos de Uso.",
        type: "error",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Remover meu usuário",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.$refs["termsOfUseModal"].hide();
          this.$store.dispatch("user/removeUser");
          this.$store.dispatch("user/signOut");
          this.$router.push("/");
        }
        this.isLoading = false;
      });
    },

    accept() {
      this.isLoading = true;

      this.$store
        .dispatch("user/acceptTermsOfUse", { source: "carreiras" })
        .then((response) => {
          if (response.data.acceptTermsOfUse.success) {
            this.isLoading = false;
            this.$refs["termsOfUseModal"].hide();
          } else {
            this.$swal(
              "Uoops",
              "Ocorreu um problema ao aceitar os termos. Tente novamente em instantes.",
              "error"
            ).then(() => {
              this.isLoading = false;
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
